<script>
import Banner from '../components/banner'
export default {
    name: "contact",
    data() {
        return {};
    },
    computed: {},
    components: {
        Banner
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<template>
    <div class="contact">
        <Banner position="left center" :image="require('@/assets/images/contact_banner.jpg')" :title="`CONTACT US`" :desc="`Get in touch with us through any of the methods listed below.`"/>
        <div class="wrapper layout_main">
            <div class="list">
                <div class="item flex align_center">
                    <img src="@/assets/images/contact_map_01.jpg" alt="" class="cover border"/>
                    <div class="content flex flex_column">
                        <p class="title">London Campus</p>
                        <p class="text">63 ST MARY AXE<br/>LONDON<br/>United Kingdom<br/>EC3A 8AA</p>
                    </div>
                </div>
                <div class="item flex align_center">
                    <img src="@/assets/images/contact_map_02.jpg" alt="" class="cover border"/>
                    <div class="content flex flex_column">
                        <p class="title">Manchester<br/>Campus</p>
                        <p class="text">St James Tower,<br/>7 Charlotte St,<br/>Manchester M1 4DZ</p>
                    </div>
                </div>
            </div>
            <div class="list">
                <div class="item flex align_start">
                    <img src="@/assets/images/contact_img_01_mobile.jpg" alt="" class="cover" data-type="mobile"/>
                    <div class="content flex flex_column type2">
                        <p class="title">Call Us</p>
                        <p class="text">
                            <span>London Office</span>
                            <br/>
                            <a href="tel:+44(0)2030093414">+44 (0)2030093414</a>
                            <br/>
                            <br/>
                            <span>Manchester Office</span>
                            <br/>
                            <a href="tel:+447702703824">+44 7702703824</a>
                            <br/>
                            <br/>
                            <span>E-MAIL US</span>
                            <br/>
                            <a href="mailto:info@oaluk.com">info@oaluk.com</a>
                        </p>
                    </div>
                    <img src="@/assets/images/contact_img_01.jpg" alt="" class="cover" data-type="pc"/>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.wrapper{
    padding: .8rem 0;
    [data-type=pc]{
        @media only screen and (max-width: 750px) {
            display: none;
        }
    }
    [data-type=mobile]{
        display: none;
        @media only screen and (max-width: 750px) {
            display: block;
            &.flex{
                display: flex;
            }
        }
    }
}
.list{
    margin-bottom: .8rem;
    .item,
    &:last-child{
        margin-bottom: 0;
    }
    @media only screen and (max-width: 750px) {
        display: flex;
        flex-direction: column;
        gap: .8rem 0;
    }
    .item{
        gap: 0 .8rem;
        margin-bottom: .4rem;
        @media only screen and (max-width: 750px) {
            flex-direction: column;
            margin-bottom: 0;
        }
        .cover{
            width: 6.9rem;
            flex-shrink: 0;
            &.border{
                border: 1px solid #666;
            }
            @media only screen and (max-width: 750px) {
                margin-bottom: .4rem;
            }
        }
        .content{
            flex-grow: 1;
            @media only screen and (max-width: 750px) {
                width: 100%;
                align-items: center;
                text-align: center;
            }
            &.type2{
                .title{
                    margin-bottom: .4rem;
                }
                .text{
                    color: #666;
                    line-height: 1.4;
                    span{
                        color: var(--color-blue);
                        line-height: 1;
                    }
                }
            }
            .title{
                font-size: .56rem;
                font-weight: bold;
                margin-bottom: .6rem;
                @media only screen and (max-width: 750px) {
                    font-size: .44rem;
                    margin-bottom: .3rem;
                }
            }
            .text{
                font-size: .32rem;
                line-height: 1.2;
                @media only screen and (max-width: 750px) {
                    font-size: .24rem;
                }
            }
        }
    }
}
</style>